export default __webpack_public_path__ + "static/media/backer-traveler-capital.02ad5fd5.png";